interface IIconProps {
  size?: number;
}

export const EfdaIcon = ({ size = 48 }: IIconProps) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24.0002" cy="23.9997" r="22.8571" fill="#E7F0F3" />
    <path
      d="M21.7431 25.9415V17.2819C21.7431 15.0635 21.14 12.8856 19.9983 10.9834C19.8509 10.7382 19.5861 10.5879 19.2997 10.5879C19.0134 10.5879 18.7486 10.7382 18.6012 10.9834C17.4601 12.8856 16.8564 15.0635 16.8564 17.2819V25.9415H21.7425H21.7431Z"
      fill="#83B2BE"
    />
    <path
      d="M23.6431 31.326C22.944 31.326 22.292 31.5312 21.7432 31.8837V27.8096H20.1147V34.8549C20.1147 36.8008 21.6979 38.3839 23.6437 38.3839C25.5895 38.3839 27.1726 36.8008 27.1726 34.8549C27.1726 32.9091 25.5889 31.326 23.6431 31.326ZM23.6431 36.7548C22.5956 36.7548 21.7432 35.9024 21.7432 34.8549C21.7432 33.8075 22.5956 32.9551 23.6431 32.9551C24.6906 32.9551 25.543 33.8075 25.543 34.8549C25.543 35.9024 24.6906 36.7548 23.6431 36.7548Z"
      fill="#83B2BE"
      stroke="#83B2BE"
      strokeWidth="0.5"
    />
    <path
      d="M16.8575 27.8096V31.8837C16.3088 31.5312 15.6568 31.326 14.9577 31.326C13.0118 31.326 11.4287 32.9091 11.4287 34.8549C11.4287 36.8008 13.0118 38.3839 14.9577 38.3839C16.9035 38.3839 18.4866 36.8008 18.4866 34.8549V27.8096H16.8581H16.8575ZM14.9571 36.7548C13.9096 36.7548 13.0572 35.9024 13.0572 34.8549C13.0572 33.8075 13.9096 32.9551 14.9571 32.9551C16.0045 32.9551 16.8569 33.8075 16.8569 34.8549C16.8569 35.9024 16.0045 36.7548 14.9571 36.7548Z"
      fill="#83B2BE"
      stroke="#83B2BE"
      strokeWidth="0.5"
    />
    <path
      d="M34.3186 10.8946C33.9243 10.5015 33.4005 10.2855 32.8434 10.2861L29.5316 10.2909L27.7987 12.5535L25.9531 12.5564L25.9549 13.8533L27.8411 13.8503L29.179 15.2557L28.5217 20.5187L28.5295 25.9105L33.4017 25.9034L33.391 20.5115L33.3809 15.941C34.2744 15.7048 34.9342 14.8882 34.933 13.9219L34.9306 12.368C34.93 11.8108 34.7123 11.2877 34.318 10.8946H34.3186Z"
      fill="#83B2BE"
    />
    <path
      d="M33.4229 35.933L33.4062 27.8115L28.5327 27.8187L28.5446 35.9473V36.2325H28.5619C28.7051 37.4446 29.7365 38.3847 30.9874 38.3829C32.2376 38.3811 33.2666 37.4386 33.4062 36.2259H33.4235V35.9473C33.4235 35.9449 33.4235 35.9425 33.4235 35.9408C33.4235 35.9384 33.4235 35.936 33.4235 35.9336L33.4229 35.933Z"
      fill="#83B2BE"
    />
  </svg>
);
